import { Component, Input } from '@angular/core';
import { OperationalAssurancesSection } from 'src/app/model/shared/operational-assurance-section.';

@Component({
  selector: 'app-known-issues-section',
  templateUrl: './known-issues-section.component.html',
  styleUrls: ['./known-issues-section.component.scss']
})
export class KnownIssuesSectionComponent {
  @Input() sections: OperationalAssurancesSection[] = [];
}
